/*
 *
 * CartPage reducer
 *
 */

import produce from 'immer';

export const key = 'cartPage';
export const initialState = null;

/* eslint-disable no-param-reassign, default-case */
function cartPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            default:
                return draft;
        }
    });
}

export default cartPageReducer;
